<script>
export default {
  data () {
    return { sessionData: [] }
  },
  mounted: function () {
    console.log('SessionData mounted ', new Date())
  },
  methods: {
    getSessionData: function () {
      return this.sessionData
    },
    addToSessionData: function (someData) {
      this.sessionData.push(someData)
      console.log('SessionData: ', this.sessionData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SessionData.vue